import React, { useState } from 'react';
import { Box, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import AccessMeeting from './components/AccessMeeting';
import AllowParticipant from './components/AllowParticipant';
import ControllerCTH from './components/ControllerCTH';
import ControllerMeeting from './components/ControllerMeeting';
import ControllerParticipant from './components/ControllerParticipant';
import Desc from './components/Desc';
import GeneralSettings from './components/GeneralSettings';
import HeaderMenuController from './components/HeaderMenuController';
import SideBar from './components/SideBar';
import { toggleDialog } from './slice';
import './style.css';
const MenuController = () => {
    const { isOpen } = useSelector((state) => state['features/moderator-controller']);
    const [openSideBarLeft, setOpenSideBarLeft] = useState(true);
    const dispatch = useDispatch();
    const handleCloseDialog = () => {
        dispatch(toggleDialog());
    };
    return (React.createElement(React.Fragment, null, isOpen &&
        React.createElement("div", { className: 'menuControllerWrapper' },
            React.createElement(HeaderMenuController, { headerTitle: 'menuController.header', closeDialog: handleCloseDialog }),
            React.createElement(SideBar, { textSideBarLeft: 'menuController.titleControleRoom', textSideBarRight: 'menuController.titleControlCTH', openSideBarLeft: openSideBarLeft, setOpenSideBarLeft: setOpenSideBarLeft }),
            React.createElement(Box, { sx: { margin: '0 0 0 16px' } },
                React.createElement(Desc, null),
                React.createElement(Stack, { id: "menu-controller-room", sx: {
                        height: `calc(100vh - 88px - 37px - 72px - 52px - 80px)`,
                        overflow: 'auto',
                        overflowX: 'hidden',
                        marginRight: '4px',
                        paddingRight: '6px'
                    } }, openSideBarLeft ?
                    React.createElement(React.Fragment, null,
                        React.createElement(ControllerParticipant, null),
                        React.createElement(ControllerMeeting, null),
                        React.createElement(GeneralSettings, null),
                        React.createElement(AllowParticipant, null),
                        React.createElement(AccessMeeting, null))
                    :
                        React.createElement(ControllerCTH, null))))));
};
export default MenuController;
